<template>
  <tab-list
      v-model="currentTab"
      :tabs-enum="tabs"
      :title="title"
      fixed-tabs
      :default-tab="defaultTab"
      @change="changeTab">
    <template v-slot:tabItem="{ current }">
      <general-error v-if="!!generalError" />
      <trade-request-list
          :request-type="requestType"
          :status="current" />
    </template>
  </tab-list>
</template>

<script>
  import TradeRequestList from '@/components/pages/admin/Lots/Requests/TradeRequestList.vue'
  import TabList from '@/components/reused/ui/TabList.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { LOT_REQUEST_STATUS_ENUM } from '@/constants/enums'
  import { LOT_REQUEST_STATUSES, LOT_REQUEST_TYPES } from '@/constants/business'

  export default {
    components: {
      TabList,
      TradeRequestList,
      GeneralError
    },
    props: {
      tab: {
        type: String
      },
      requestType: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        currentTab: this.tab || LOT_REQUEST_STATUSES.INPROCESS,
        defaultTab: LOT_REQUEST_STATUSES.APPROVED
      }
    },
    computed: {
      tabs () {
        return LOT_REQUEST_STATUS_ENUM
      },
      title () {
        switch (this.requestType) {
        case LOT_REQUEST_TYPES.REGISTRATION:
          return this.$t('Список запросов на регистрацию торговой процедуры')
        case LOT_REQUEST_TYPES.RECALL:
          return this.$t('Список запросов на отзыв торговой процедуры')
        case LOT_REQUEST_TYPES.CHANGE_DOCUMENTS:
          return this.$t('Список запросов на изменения в документации по торговой процедуре')
        case LOT_REQUEST_TYPES.CONTRACT_CONDITION_FAIL:
          return this.$t('Список уведомлений о неисполнении договора')
        default:
          return this.$t('Список запросов')
        }
      }
    },
    methods: {
      changeTab: function (tabValue) {
        this.replaceCurrentRoute(this.getRoute(tabValue))
      },
      getRoute: function (tabValue) {
        return `${this.urlRootPath}/tradeRequests/${this.requestType}/${tabValue}`
      }
    }
  }
</script>
